import { render, staticRenderFns } from "./password-reset-form.vue?vue&type=template&id=20b638e3"
import script from "./password-reset-form.vue?vue&type=script&lang=js"
export * from "./password-reset-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports